import { Injectable, OnDestroy } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig, MatSnackBarRef } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { AlertMessage } from '@tekman/shared/models';
import { Subscription } from 'rxjs';
import { SnackBarComponent } from '@tekman/shared/component/generic';

@Injectable({
  providedIn: 'root',
})
export class AlertService implements OnDestroy {
  private messageQueue: Array<AlertMessage> = Array<AlertMessage>();
  private subscription: Subscription;
  private snackBarRef: MatSnackBarRef<SnackBarComponent>;
  private isInstanceVisible = false;

  constructor(private readonly _snackBar: MatSnackBar, private readonly translate: TranslateService) {}

  openAlert(message: string, success = true, duration = 5000, loading = false): void {
    const config: MatSnackBarConfig = {
      duration: duration,
      panelClass: ['alert', success ? 'success-snackbar' : 'error-snackbar'],
      horizontalPosition: 'end',
      verticalPosition: 'top',
    };
    const alertMessage = new AlertMessage();
    alertMessage.message = message === undefined ? this.translate.instant('f.activity.alert.error') : message;
    alertMessage.config = config;
    alertMessage.loading = loading;
    this.messageQueue.push(alertMessage);
    if (!this.isInstanceVisible) {
      this.showNextAlert();
    }
  }

  private showNextAlert() {
    if (this.messageQueue.length === 0) {
      return;
    }
    const message = this.messageQueue.shift();
    this.isInstanceVisible = true;
    this.snackBarRef = this._snackBar.openFromComponent(SnackBarComponent, {
      data: { message: message.message, loading: message.loading },
      ...message.config,
    });
    this.subscription = this.snackBarRef.afterDismissed().subscribe(() => {
      this.isInstanceVisible = false;
      this.showNextAlert();
    });
  }

  closeAlert() {
    this.messageQueue.shift();
    this.snackBarRef.dismiss();
  }

  ngOnDestroy() {
    this.subscription && this.subscription.unsubscribe();
  }
}
